import SupportPage from './SupportPage.component';

export default SupportPage;
